<template>
  <div class="c-project g-container">
    <moduler :ref="item.href" v-for="item in subModules" :name="item.href" :key="item.id" :title="item.name">
      <!-- 投放方式 -->
      <template v-if="item.href === 'basic'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">游戏平台</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="project.platform" type="button" @on-change="gameChange">
              <Radio :label="1" :disabled="editState">Android</Radio>
              <Radio :label="2" :disabled="editState">iOS</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">投放游戏</span>
          </Col>
          <Col span="12">
            <auto-complete
              v-model="project.gameId"
              :data="platformGameData"
              :disabled="modifiesState"
              placeholder="请选择推广游戏"
              style="width: 320px"
              @on-select="handleGame"
            />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="project.launchType" type="button">
              <Radio :label="1">APP应用</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">游戏包名</span>
          </Col>
          <Col span="12">
            <Input v-model="project.package" placeholder="App应用包名称" disabled style="width: 280px" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="project.platform === 1">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">头条APPID</span>
          </Col>
          <Col span="12">
            <Input v-model="project.app_id" placeholder="App应用头条APPID" disabled style="width: 280px" />
          </Col>
        </Row>
      </template>
      <!-- 用户定向池 -->
      <template v-if="item.href === 'audience'" slot="head">
        <div class="box-inline">
          <span class="span-num"
            ><ins>{{ targets.length }}</ins
            >/{{ lenTarget }}</span
          >
          <Button type="primary" @click="handleTarget">选择定向包</Button>
          <Poptip v-if="targets.length" confirm title="确定要清空？" class="pop-btn" @on-ok="targets = []">
            <Icon type="ios-trash-outline" size="22" color="#ff2200" />
            <span>清空全部</span>
          </Poptip>
        </div>
      </template>
      <template v-if="item.href === 'audience'">
        <target-select
          ref="TargetSelect"
          :value="targets"
          :orign-data="orignData"
          :open-id="opId"
          :media="media"
          :platform="project.platform"
          @on-select="appendTarget"
          @on-delete="delTarget"
        />
      </template>
      <!-- 创意池 -->
      <template v-if="item.href === 'creative'" slot="head">
        <div class="box-inline">
          <span class="span-sub">程序化创意</span>
          <span class="span-num span-idea-sub">每个计划配置</span>
          <input-number-plus
            v-model="project.maxImageCount"
            readonly
            :disabled="modifiesState"
            :max="2"
            :min="1"
            :precision="0"
            :width="60"
            placeholder="请输入"
          />
          <span class="span-num span-idea-sub">视频，</span>
          <input-number-plus
            v-model="project.maxDocumentCount"
            :disabled="modifiesState"
            :max="2"
            :min="1"
            :precision="0"
            :width="60"
            placeholder="请输入"
          />
          <span class="span-num span-idea-sub">文案</span>
        </div>
      </template>
      <template v-if="item.href === 'creative'">
        <!-- 视频素材 -->
        <mater-select
          :value="materies"
          :max="lenMarter"
          :game-id="project.gameId"
          :media="media"
          :words="wordIds"
          type="video"
          @on-replace="replaceMate"
          @on-select="appendMate"
          @on-delete="delMaterail"
          @on-clear="materies = []"
        />
        <!-- 图片素材 -->
        <mater-select
          :value="materiesImage"
          :max="lenMarter"
          :game-id="project.gameId"
          :media="media"
          :words="wordIds"
          type="large"
          @on-replace="replaceImage"
          @on-select="appendImage"
          @on-delete="delMaterailIm"
          @on-clear="materiesImage = []"
        />
        <document-select
          :value="documents"
          :max="lenDocument"
          :words="wordIds"
          :open-id="opId"
          @on-update="replceDocument"
          @on-select="appendDocument"
          @on-delete="delDocument"
          @on-clear="documents = []"
        />
      </template>
      <!-- 策略池 -->
      <template v-if="item.href === 'policy'" slot="head">
        <div class="box-inline">
          <span class="span-num"
            ><ins>{{ policies.length }}</ins
            >/{{ lenPolicy }}</span
          >
          <Button type="primary" @click="handlePolicy">选择模板</Button>
          <Poptip v-if="policies.length" confirm title="确定要清空？" class="pop-btn" @on-ok="policies = []">
            <Icon type="ios-trash-outline" size="22" color="#ff2200" />
            <span>清空全部</span>
          </Poptip>
        </div>
      </template>
      <template v-if="item.href === 'policy'">
        <policy-select
          ref="PolicySelect"
          :value="policies"
          :open-id="opId"
          :media="media"
          :platform="project.platform"
          @on-select="appendPolicy"
          @on-delete="delPolicy"
        />
      </template>
    </moduler>

    <!-- 下一步 -->
    <affix target="c-project" :offset-bottom="0">
      <div class="ad-submit">
        <Row class="ad-submit-moduler">
          <Col :span="12">
            <error-pop v-model="formErr" :data="errRes" :state="Boolean(errRes.length)" @close="errRes = []" />
          </Col>
          <Col :span="12" class="ad-submit-control">
            <template v-if="modifiesState">
              <Button type="primary" @click="submitToNext">下一步</Button>
            </template>
            <template v-else>
              <Button @click="cannel">取消</Button>
              <Button type="primary" :loading="loading" @click.stop="submitToNext">
                <span v-if="!loading">下一步</span>
                <span v-else>提交中...</span>
              </Button>
            </template>
          </Col>
        </Row>
      </div>
    </affix>
  </div>
</template>
<script>
import mixin from './mixin'
import { deCompile } from '@/common/js/decompile'
import { deepCopy, isArray, timeout } from '@/common/js/utils'
import { getSession, setSession } from '@/common/js/api'

import TargetSelect from './components/target-select'
import PolicySelect from './components/policy-select'
import MaterSelect from './components/material-select'
import DocumentSelect from './components/document-select'

import { getCaoHuaGames, getGameAppid } from '@/api/common.model'
import { getCreativeWordIds } from '@/api/toutiao.model'
import { getMonitorProject, queryManageIdByMedia } from '@/api/manage.model'

export default {
  name: 'Project',
  mixins: [mixin],
  components: { TargetSelect, PolicySelect, MaterSelect, DocumentSelect },
  computed: {
    editState() {
      return Boolean(this.$route.query) && this.$route.query.t === 'edit'
    },
    backState() {
      return Boolean(this.$route.query) && this.$route.query.g === 'back'
    },
    detState() {
      return Boolean(this.$route.query) && Boolean(this.$route.query.id)
    },
    modifiesState() {
      return this.editState && this.detState
    },
    platformGameData() {
      return this.dataGames.filter((ret) => this.modifiesState || ret.ch_platform_id === this.project.platform)
    }
  },
  data() {
    return {
      toutiaoManageId: null,
      project: {
        platform: 1,
        gameId: 0,
        package: '',
        app_id: '',
        launchType: 1,
        maxImageCount: 1,
        maxDocumentCount: 3
      },
      dataGames: [],
      wordIds: [],
      lenTarget: 50,
      lenMarter: 50,
      lenDocument: 50,
      lenPolicy: 50,
      targets: [],
      materies: [],
      materiesImage: [],
      documents: [],
      policies: []
    }
  },
  methods: {
    getData() {
      const { id } = this.$route.query
      getMonitorProject({ projectId: id }).then((data) => {
        if (data && data.frontSubmit) {
          const {
            launchType,
            platform,
            adPackage,
            gameId,
            appid,
            maxImageCount,
            maxDocumentCount,
            targetingIds,
            imageDetailIds,
            documentIds,
            strategyIds,
            frontSubmit: { targets, materies, materiesImage, documents, policies },
            creatives,
            targetings
          } = data // 接口获取值
          this.project = Object.assign({}, this.project, {
            platform,
            package: adPackage,
            launchType,
            gameId,
            app_id: appid,
            maxImageCount,
            maxDocumentCount,
            targetingIds,
            imageDetailIds,
            documentIds,
            strategyIds
          })
          if (isArray(targetings)) {
            this.targets = targetings.map((ret) => {
              ret.targets = deCompile(ret.targetingParamJson, this.orignData)
              return ret
            })
          } else if (isArray(targets)) this.targets = targets
          else this.targets = []
          const videoIds = materies && isArray(materies) ? materies.map((ret) => ret.children[0].id) : []
          const imageIds = materiesImage ? materiesImage.map((ret) => ret.id) : []
          if (isArray(creatives)) {
            this.materies = creatives
              .filter((ret) => videoIds.includes(ret.id))
              .map((ret) => {
                const video = Object.assign({}, ret, {
                  image_mode: 'CREATIVE_IMAGE_MODE_VIDEO',
                  msg: '',
                  op_id: {},
                  poster_url: ret.cover_url,
                  url: ret.source_url
                })
                const cover = Object.assign({}, ret, {
                  image_mode: 'CREATIVE_IMAGE_MODE_VIDEO',
                  msg: '',
                  op_id: {},
                  url: ret.cover_url
                })
                return { title: '', creative_word_ids: [], children: [video, cover] }
              })
            this.materiesImage = materiesImage ? materiesImage.filter((ret) => imageIds.includes(ret.id)) : []
          } else if (isArray(materies) && imageDetailIds) {
            this.materies = materies
            this.materiesImage = materiesImage || []
          } else {
            this.materies = []
            this.materiesImage = []
          }
          this.documents = documents
          this.policies = policies
        }
        this.$Spin.hide()
      })
    },
    gameChange() {
      this.project.gameId = ''
    },
    async handleGame(meta) {
      this.project.gameId = meta.id
      this.project.package = meta.ad_package // 更改成显示包名
      if (this.project.platform === 1 && meta.id) {
        const appId = await getGameAppid({ mediaId: this.media, gameId: meta.id })
        if (appId) this.project.app_id = appId
      } else this.project.app_id = ''
    },
    // 添加定向
    handleTarget() {
      this.$refs.TargetSelect[0].selectTarget()
    },
    // 删除定向
    delTarget(index) {
      this.targets.splice(index, 1)
    },
    appendTarget(target) {
      const origin = deepCopy(this.targets)
      let selection = [...target, ...origin]
      selection = selection.filter((ret, idx) => selection.findIndex((met) => met.targetingId === ret.targetingId) === idx)
      if (!this.modifiesState && selection.length > this.lenTarget) {
        const len = selection.length - this.lenTarget
        selection.splice(49, len)
      }
      this.targets = selection
    },
    // 添加策略
    handlePolicy() {
      this.$refs.PolicySelect[0].selectPolicy()
    },
    delPolicy(index) {
      this.policies.splice(index, 1)
    },
    appendPolicy(policy) {
      const origin = deepCopy(this.policies)
      let selection = [...policy, ...origin]
      selection = selection.filter((ret, idx) => selection.findIndex((met) => met.id === ret.id) === idx)
      if (!this.modifiesState && selection.length > this.lenTarget) {
        const len = selection.length - this.lenPolicy
        selection.splice(49, len)
      }
      this.policies = selection
    },
    replceDocument({ item, index }) {
      this.documents.splice(index, 1, item)
    },
    delDocument(index) {
      this.documents.splice(index, 1)
    },
    appendDocument(item) {
      const origin = deepCopy(this.documents)
      let selection = [...item, ...origin]
      selection = selection.filter((ret, idx) => selection.findIndex((met) => met.docId === ret.docId) === idx)
      if (!this.modifiesState && selection.length > this.lenDocument) {
        const len = selection.length - this.lenDocument
        selection.splice(49, len)
      }
      this.documents = selection
    },
    // 原始选择素材
    appendMate(list) {
      if (!isArray(list)) return
      const multCreative = list.map((m) => {
        if (isArray(m.items)) {
          // 判断服务端错误
          const pop = m.items.pop()
          const { video, cover } = pop
          return { title: '', creative_word_ids: [], children: [video.pop(), cover.pop()] }
        }
      })
      this.appendMaterail(multCreative)
    },
    appendImage(list) {
      if (!isArray(list)) return
      const multCreative = list.map((m) => {
        if (isArray(m.items)) {
          // 判断服务端错误
          return m.items.pop()
          // return { title: '', creative_word_ids: [], children: pop }
        }
      })
      this.appendImageMater(multCreative)
    },
    // 多选视频
    appendMaterail(item) {
      const origin = deepCopy(this.materies)
      let selection = [...item, ...origin]
      selection = selection.filter((ret, idx) => selection.findIndex((met) => met.children[0].id === ret.children[0].id) === idx)
      if (!this.modifiesState && selection.length > this.lenMarter) {
        const len = selection.length - this.lenMarter
        selection.splice(49, len)
      }
      this.materies = selection
    },
    // 多选图片
    appendImageMater(item) {
      const origin = deepCopy(this.materiesImage)
      const selection = [...item, ...origin]
      // selection = selection.filter((ret, idx) => selection.findIndex(met => met.children[0].id === ret.children[0].id) === idx)
      if (!this.modifiesState && selection.length > this.lenMarter) {
        const len = selection.length - this.lenMarter
        selection.splice(49, len)
      }
      this.materiesImage = selection
    },
    delMaterail(index) {
      this.materies.splice(index, 1)
    },
    delMaterailIm(index) {
      this.materiesImage.splice(index, 1)
    },
    replaceMate({ index, item }) {
      if (isArray(item)) {
        // 封面
        const [video] = deepCopy(this.materies[index].children)
        this.$set(this.materies[index], 'children', [video, item.pop()])
      } else {
        // 视频替换
        const { video, cover } = item
        this.materies.splice(index, 1, { title: '', creative_word_ids: [], children: [video.pop(), cover.pop()] })
      }
    },
    replaceImage({ index, item }) {
      if (item) this.materiesImage.splice(index, 1, ...item)
    },
    proload() {
      this.$Spin.show()
      Promise.all([getCaoHuaGames(), getCreativeWordIds({ account: this.toutiaoManageId })]).then((data) => {
        // 获取创意词包
        const myWordIds = [1736, 1727, 4, 1737, 5128, 5127]
        const projectParams = getSession('project_params')

        if (data) {
          const [games, creativeWord] = data
          this.dataGames = games
          if (creativeWord && creativeWord.creative_word) {
            this.wordIds = creativeWord.creative_word.filter((ret) => myWordIds.includes(ret.creative_word_id))
          }
          if (projectParams) {
            const { targets, materies, materiesImage, delMaterailImage, documents, policies } = projectParams
            this.project = Object.assign({}, this.project, projectParams)
            this.targets = targets
            this.materies = materies
            this.materiesImage = materiesImage
            this.delMaterailImage = delMaterailImage
            this.documents = documents
            this.policies = policies
            this.$Spin.hide()
          } else if (this.detState) this.getData()
          else this.$Spin.hide()
        }
      })
    },
    valid() {
      const rules = [
        {
          name: 'project/gameId',
          require: true,
          min: 1,
          desc: '投放游戏'
        },
        {
          name: 'project/app_id',
          require: true,
          relyon: 'project/platform',
          relyvalue: 1,
          min: 1,
          desc: '头条APPID'
        },
        {
          name: 'project/package',
          require: true,
          min: 1,
          desc: '游戏包名'
        },
        {
          name: 'project/maxImageCount',
          require: true,
          min: 1,
          desc: '计划素材数量'
        },
        {
          name: 'project/maxDocumentCount',
          require: true,
          min: 1,
          desc: '计划文案数量'
        },
        {
          name: 'documents',
          require: true,
          min: 1,
          desc: '文案库'
        },
        {
          name: 'policies',
          require: true,
          min: 1,
          desc: '策略池'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submitToNext() {
      this.formErr = false
      this.errRes = this.valid() // 表单验证

      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      const params = Object.assign({}, this.project, {
        targets: this.targets,
        materies: this.materies,
        materiesImage: this.materiesImage,
        delMaterailImage: this.delMaterailImage,
        documents: this.documents,
        policies: this.policies
      })
      !this.modifiesState && (this.loading = true)
      setSession('project_params', params)
      timeout(0).then(() => {
        this.loading = false
        if (this.backState) this.$router.push({ name: 'robotmonitor', query: this.$route.query })
        else this.$router.push({ name: 'robotmonitor' })
      })
    }
  },
  watch: {
    targets(nVal) {
      this.project.targetingIdList = nVal.map((ret) => ret.targetingId)
    },
    materies(nVal) {
      this.project.videoIdList = nVal.map((ret) => ret.children[0].id)
      const imageIdList = this.project.imageIdList ? this.project.imageIdList : []
      this.project.imageDetailIdList = [...this.project.videoIdList, ...imageIdList]
    },
    materiesImage(nVal) {
      this.project.imageIdList = nVal.map((ret) => ret.id)
      const videoIdList = this.project.videoIdList ? this.project.videoIdList : []
      this.project.imageDetailIdList = [...videoIdList, ...this.project.imageIdList]
    },
    documents(nVal) {
      this.project.documentIdList = nVal.map((ret) => ret.docId)
    },
    policies(nVal) {
      this.project.strategyIdList = nVal.map((ret) => ret.id)
    }
  },
  created() {
    queryManageIdByMedia().then((data) => {
      if (data && isArray(data)) {
        this.toutiaoManageId = data.filter((m) => m.mediaId === 10).pop().manageId
        this.proload()
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.c-project {
  position: relative;
  padding-bottom: 68px;

  .box-inline {
    display: inline-block;
    line-height: 32px;

    > * {
      display: inline-block;
      vertical-align: middle;
    }

    .span-num,
    .span-sub {
      font-size: 15px;
      padding-left: 26px;
      padding-right: 26px;
      margin: 0;
    }

    .span-sub {
      color: #999;
      padding-left: 10px;
    }

    .span-idea-sub {
      padding-left: 10px;
      padding-right: 10px;
    }

    .pop-btn {
      margin-left: 26px;
      font-size: 14px;
      cursor: pointer;

      i {
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }

  .ad-group,
  .ad-submit {
    padding: 15px 0 0 0;

    .ad-group-moduler,
    .ad-submit-moduler {
      padding: 16px 24px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      border-radius: 2px;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.05);
    }
  }

  .ad-submit {
    padding-bottom: 0;

    .ad-submit-moduler {
      display: flex;
      justify-content: flex-end;
    }

    .ad-submit-control {
      text-align: right;

      button {
        margin-left: 6px !important;
      }
    }
  }
}
</style>
